import React from "react";
import { gbp, pct } from "../lib/iht";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

const Row = ({ label, value, note, testid }) => (
  <div className="flex items-start justify-between gap-4 py-2.5 border-b-2 border-dashed border-foreground/15 last:border-0">
    <div>
      <p className="font-bold text-sm">{label}</p>
      {note && <p className="text-xs text-muted-foreground">{note}</p>}
    </div>
    <p data-testid={testid} className="font-mono font-bold text-sm whitespace-nowrap">{value}</p>
  </div>
);

export const Breakdown = ({ r }) => (
  <div className="flex flex-col gap-6">
    <div>
      <h3 className="text-lg font-bold mb-2">The breakdown</h3>
      <div className="rounded-xl border-2 border-foreground bg-white p-4 brutal-shadow-sm">
        <Row testid="bd-net-estate" label="Net estate" note="After debts & funeral costs" value={gbp(r.netEstate)} />
        <Row testid="bd-nrb" label="Nil-rate band used" note={r.spouseNrbApplied ? "Includes transfer from late spouse" : "Standard allowance"} value={gbp(r.nrb)} />
        <Row testid="bd-rnrb" label="Residence nil-rate band" note={r.rnrb === 0 ? "Not available" : r.rnrbTapered ? `Tapered down by ${gbp(r.taper)}` : r.spouseRnrbApplied ? "Includes spouse transfer" : "Applied to your home"} value={gbp(r.rnrb)} />
        <Row testid="bd-charity" label="Charity legacy" note={r.charityRateApplied ? "10%+ test met — 36% rate applied" : "Below 10% — 40% rate"} value={gbp(r.charity)} />
        <Row testid="bd-gifts" label="Chargeable gifts" note={`Taper rate on tax: ${pct(r.giftRate)}`} value={gbp(r.giftsChargeable)} />
        <Row testid="bd-rate" label="Applied tax rate" value={pct(r.rate)} />
      </div>
    </div>

    <Accordion type="single" collapsible className="rounded-xl border-2 border-foreground bg-white overflow-hidden brutal-shadow-sm" data-testid="how-it-works">
      <AccordionItem value="how" className="border-0">
        <AccordionTrigger className="px-4 font-bold hover:no-underline hover:bg-primary/40 data-[state=open]:bg-primary">
          How this is worked out
        </AccordionTrigger>
        <AccordionContent className="px-4 pb-4 text-sm leading-relaxed space-y-3">
          <p><span className="font-bold">Allowances first.</span> We subtract your Nil-Rate Band (£325k) and Residence Nil-Rate Band (up to £175k, for homes left to descendants) from your net estate. Both can be doubled if inherited from a late spouse.</p>
          <p><span className="font-bold">Taper.</span> Estates over £2m lose £1 of residence allowance for every £2 above the threshold.</p>
          <p><span className="font-bold">Charity.</span> Leaving 10%+ of the taxable baseline to charity cuts the rate from 40% to 36%.</p>
          <p><span className="font-bold">Gifts.</span> Gifts in the last 7 years above the remaining NRB are taxed, with taper relief reducing the tax from 3 years onward.</p>
          <p className="text-xs text-muted-foreground">Based on 2026/27 thresholds. A simplified consumer estimate — not a full professional tax engine.</p>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  </div>
);
